const parse = (value?: string): Date | null => {
  if (!value) return null;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
};

export const formatDate = (value: string | undefined, locale: string): string => {
  const d = parse(value);
  if (!d) return '—';
  return d.toLocaleDateString(locale, { day: '2-digit', month: 'short', year: 'numeric' });
};

export const formatDateTime = (value: string | undefined, locale: string): string => {
  const d = parse(value);
  if (!d) return '—';
  return d.toLocaleString(locale, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Compact relative label
export const formatRelative = (value: string | undefined, locale: string): string => {
  const d = parse(value);
  if (!d) return '—';
  const diffMs = d.getTime() - Date.now();
  const diffMin = Math.round(diffMs / 60000);
  const abs = Math.abs(diffMin);
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
  if (abs < 1) return rtf.format(0, 'minute');
  if (abs < 60) return rtf.format(diffMin, 'minute');
  const diffHour = Math.round(diffMin / 60);
  if (Math.abs(diffHour) < 24) return rtf.format(diffHour, 'hour');
  const diffDay = Math.round(diffHour / 24);
  if (Math.abs(diffDay) < 7) return rtf.format(diffDay, 'day');
  return formatDate(value, locale);
};

export const ticketRef = (id?: number): string =>
  id === undefined ? '#—' : `#${String(id).padStart(6, '0')}`;
